import { FormTemplate } from 'data/template/template.types';

// eslint-disable-next-line import/prefer-default-export
export const iriBufferingTemplate: FormTemplate = {
  version: '1.0.0',
  name: 'IRI Buffering',
  key: 'iriBufferingTemplate',
  main: {
    metadata: {
      layout: {
        rows: [
          ['id'],
          ['NAME', 'description', '$empty'],
          ['iriFile', '$empty', '$empty'],
          ['IRISIZE', 'IRIEXP', 'IRIEXPMNT'],
          ['IRICLEAR', '$empty', '$empty'],
        ],
      },
    },
    fields: {
      id: {
        type: 'text',
        initial: '',
        hide: 'true',
      },
      NAME: {
        label: 'Name',
        type: 'text',
        initial: '',
        options: [],
        validation: {
          required: true,
        },
      },
      description: {
        label: 'Description',
        type: 'text',
        initial: '',
        options: [],
        validation: {
          required: false,
        },
      },
      IRISIZE: {
        label: 'Maximum Size',
        type: 'text',
        initial: '',
        validation: {
          required: false,
          validators: [
            {
              type: 'length',
              length: 164,
            },
            {
              type: 'regexp',
              regexp: ['letters', 'digits', '-_.~!@#$%^*+?/'],
              errorMessage: 'Can include letters, digits and the following special characters: -_.~!@#$%^*+?/. Please re-enter.',
            },
          ],
        },
      },
      IRIEXP: {
        label: 'Will be deleted after(days)',
        type: 'text',
        initial: '',
        validation: {
          required: false,
          validators: [
            {
              type: 'length',
              length: 164,
            },
            {
              type: 'regexp',
              regexp: ['letters', 'digits', '-_.~!@#$%^*+?/'],
              errorMessage: 'Can include letters, digits and the following special characters: -_.~!@#$%^*+?/. Please re-enter.',
            },
          ],
        },
      },
      IRIEXPMNT: {
        label: 'Will be deleted after(minutes)',
        type: 'text',
        initial: '',
        validation: {
          required: false,
          validators: [
            {
              type: 'length',
              length: 164,
            },
            {
              type: 'regexp',
              regexp: ['letters', 'digits', '-_.~!@#$%^*+?/'],
              errorMessage: 'Can include letters, digits and the following special characters: -_.~!@#$%^*+?/. Please re-enter.',
            },
          ],
        },
      },
      IRICLEAR: {
        type: 'checkbox',
        label: 'Clear IPCBUF after Xcipio Restart',
        initial: false,
        hide: 'false',
        validation: {
          required: false,
        },
      },
      iriFile: {
        type: 'custom',
        initial: 'IRI File',
        customComponent: 'iriFile',
        className: 'section-label',
      },
    },
  },
};
